import _findIndex from 'lodash/findIndex'
import IOApi from '@/api/IOApi'

export class GetInitialMiddleLangInitial {
  static async getInitialMiddleLang({ advertiserId }) {
    const all = await this.fetchIOListAll({
      advertiserId,
    })
    const recently = await this.fetchIOListRecently({
      advertiserId,
    })

    const allMiddleLang = this.IOListToMiddleLang(all, false)
    const recentlyMiddleLang = this.IOListToMiddleLang(recently, true)

    return this.mergeAllRecentlyMiddleLang({
      all: allMiddleLang,
      recently: recentlyMiddleLang,
    })
  }

  static async fetchIOListAll({ advertiserId }) {
    try {
      const { items } = await IOApi.fetchIOList({ advertiserId, period: 'all' })
      return items.filter(item => item.billingPeriods.length > 0)
    } catch (e) {
      throw new Error('in BudgetProgressReport')
    }
  }

  static async fetchIOListRecently({ advertiserId }) {
    try {
      const { items } = await IOApi.fetchIOList({
        advertiserId,
        period: 'recently',
      })
      return items.filter(item => item.billingPeriods.length > 0)
    } catch (e) {
      throw new Error('in BudgetProgressReport')
    }
  }

  static IOListToMiddleLang(IOList, selected) {
    try {
      return IOList.map(IO => ({
        IOId: IO.id,
        BPIds: IO.billingPeriods.map(bp => ({
          BPId: bp.id,
          selected,
          startTime: bp.startTime,
          endTime: bp.endTime,
        })),
      }))
    } catch (e) {
      throw new Error('in IOListToMiddleLang')
    }
  }

  static mergeAllRecentlyMiddleLang({ all, recently }) {
    return all.map(allItem => {
      const recentlyIndex = _findIndex(recently, { IOId: allItem.IOId })
      if (recentlyIndex >= 0) {
        const recentlyItem = recently[recentlyIndex].BPIds[0]
        const recentlyBPId = recentlyItem.BPId
        const allItemBPIDsIndex = _findIndex(allItem.BPIds, {
          BPId: recentlyBPId,
        })
        if (allItemBPIDsIndex >= 0) {
          allItem.BPIds[allItemBPIDsIndex] = recentlyItem
        }
      }
      return allItem
    })
  }
}

export const getInitialMiddleLangInitial = ({ advertiserId }) =>
  GetInitialMiddleLangInitial.getInitialMiddleLang({ advertiserId })
